import { ActionTypes } from 'src/types/types';

export const FEATURE_NAME = 'login';

export const actionTypes = {
  INIT_LOGIN: `${FEATURE_NAME}/INIT_LOGIN`,
  LOGIN: `${FEATURE_NAME}/LOGIN`,
  SEND_PIN_CODE: `${FEATURE_NAME}/SEND_PIN_CODE`,
  VERIFY_PIN_CODE: `${FEATURE_NAME}/VERIFY_PIN_CODE`,
} satisfies ActionTypes<typeof FEATURE_NAME>;
